<script>
import ViewTitle from '@/components/ViewTitle'
import Collapsible from '@/components/Collapsible'
import Button from '@/components/Button'

export default
{
    name: 'loyalty-card-edit-customers',

    created ()
    {
        this.$store.dispatch('storeLoyaltyCard/fetchCustomersDetails', {storeId: this.storeId, token: this.$store.state.user.token})
    },

    render () 
    {
        console.log(JSON.stringify(this.customers))

    return (
            <div id='loyalty-card-edit-customers-view'>
                <view-title back-action={true}>Mes clients</view-title>
                {
                    this.customers.map(c =>
                    {
                        if (!c.owner) return 

                        const lastVisits = [...c.credits.map(c => new Date(c.timestamp)), c.rewards.map(r => new Date(r.timestamp))].sort((a, b) => b - a)
                        console.log(c.credits)

                        return <collapsible icon={c.owner.profilePictureUrl} title={`${c.owner.firstName} ${c.owner.lastName}`} description-node={<div>Carte <b>{c.cardId}.</b></div>}>
                            <div class='column'>
                                <div>A accumulé un total de <b>{c.credits.reduce((a, b) => a + b.amount, 0)}</b> points lors de <b>{c.credits.length}</b> achats.</div>
                                <div>Possède actuellement <b>{c.balance.find(s => s.storeId == this.storeId).points}</b> points sur sa carte.</div>
                                {
                                    lastVisits.length > 0
                                    ? <div>Sa dernière visite date du <b>{new Intl.DateTimeFormat('fr-FR', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})
                                        .format(new Date(lastVisits[0]))}</b>.</div>
                                    : null
                                }
                                <Button text="Voir l'historique des transactions" type='light' on-click={() => this.$router.push({name: 'LoyaltyCardEditHistory', query: {search: c.cardId}})} />
                            </div>
                        </collapsible>
                    })
                }
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    computed:
    {
        storeId ()
        {
            return this.$route.params.storeId
        },

        customers ()
        {
            return this.$store.state.storeLoyaltyCard.storeCustomers[this.storeId] || []
        },

        creditHistory ()
        {
            return this.$store.state.storeLoyaltyCard.storeCreditHistory[this.storeId] || []
        },
    },

    methods:
    {
    },

    components:
    {
        ViewTitle,
        Collapsible,
        Button,
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-edit-customers-view
{
    display: flex;
    flex-direction: column;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .collapsible
    {
        &:not(:first-of-type)
        {
            margin-top: 15px;
        }

        .button
        {
            width: -webkit-fill-available;
            margin-top: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEditCustomers.vue